import { Prop } from '@typegoose/typegoose'
import { PasswordlessAuth } from './PasswordlessAuth'
import { BasicAuth } from './BasicAuth'
import { OAuth } from './OAuth'
import { LoginToken } from './LoginToken'

export class UserServicesResume {
  @Prop({ type: [LoginToken] })
  loginTokens?: LoginToken[]
}

export class UserServices {
  @Prop({ type: PasswordlessAuth })
  passwordless?: PasswordlessAuth

  @Prop({ type: BasicAuth })
  basic?: BasicAuth

  @Prop({ type: OAuth })
  google?: OAuth

  @Prop({ type: OAuth })
  facebook?: OAuth

  @Prop({ type: UserServicesResume })
  resume?: UserServicesResume
}
